import { render, staticRenderFns } from "./CheckboxApi.vue?vue&type=template&id=24ab2900&"
import script from "./CheckboxApi.vue?vue&type=script&lang=js&"
export * from "./CheckboxApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports